import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { branding, faqText } from '../../../common/text'

import * as emails from 'common/emails.json';

declare const GAMING: boolean;

@Component({
  selector: 'faq-page',
  styleUrls: ['./faq-page.component.scss'],
  templateUrl: './faq-page.component.pug'
})
export class FAQPage implements OnInit {
  public openedFaqIndex = -1;
  public faqs = faqText[GAMING ? 'gaming' : 'pfm'];
  public brand: string = branding[GAMING ? 'gaming' : 'pfm'];
  public visit: string = GAMING ? 'contact us at' : 'visit our'
  public support: string = GAMING ? emails.inquiries : 'Support Page'
  public supportLink: string = GAMING ? `mailto:${emails.inquiries}` : `https://pfm-help.freshdesk.com/support/home`

  constructor(private titleService: Title) { }

  public ngOnInit() {
    this.titleService.setTitle(`${this.brand} - FAQ`);
  }

  public onOpenFaq(index: number) {
    if (index === this.openedFaqIndex && this.openedFaqIndex !== -1) {
      this.openedFaqIndex = -1;
    } else {
      this.openedFaqIndex = index;
    }
  }
}
